import { ProblemDetails } from "../models/Http";
import { get, post, put, del } from "./api";
import { DistributorId } from "../models/Product";
import { err, ok, Result, Unit } from "../result";
import {
  StoreDistributor,
  StoreDistributorWriteModel
} from "../models/StoreDistributor";

export const list = async (
  storeId: string
): Promise<Result<ProblemDetails, ReadonlyArray<StoreDistributor>>> => {
  const response = await get(`/v1/stores/${storeId}/distributors`);
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<StoreDistributor>);
  }

  return err(content as ProblemDetails);
};

export const getSingle = async (
  storeId: string,
  distributorId: DistributorId
): Promise<Result<ProblemDetails, StoreDistributor>> => {
  const response = await get(
    `/v1/stores/${storeId}/distributors/${distributorId}`
  );
  const content = await response.json();

  if (response.ok) {
    return ok(content as StoreDistributor);
  }

  return err(content as ProblemDetails);
};

export const add = async (
  storeId: string,
  data: StoreDistributorWriteModel
): Promise<Result<ProblemDetails, StoreDistributor>> => {
  const response = await post(`/v1/stores/${storeId}/distributors`, data);
  const content = await response.json();

  if (response.ok) {
    return ok(content as StoreDistributor);
  }

  return err(content as ProblemDetails);
};

export const update = async (
  storeId: string,
  data: StoreDistributorWriteModel
): Promise<Result<ProblemDetails, StoreDistributor>> => {
  const response = await put(
    `/v1/stores/${storeId}/distributors/${data.distributorId}`,
    data
  );
  const content = await response.json();

  if (response.ok) {
    return ok(content as StoreDistributor);
  }

  return err(content as ProblemDetails);
};

export const remove = async (
  storeId: string,
  distributorId: DistributorId
): Promise<Result<ProblemDetails, Unit>> => {
  const response = await del(
    `/v1/stores/${storeId}/distributors/${distributorId}`
  );

  if (response.ok) {
    return ok({});
  }

  const content = await response.json();
  return err(content as ProblemDetails);
};
